import React from 'react';
import classnames from 'classnames';
import DeviationGrid from '../DeviationGrid';
import ContainerSize from '../../../ContainerSize';
import { compose } from 'redux';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import withFilter from '../../_hocs/withFilter';
import PollForThumbReady from '../../../DeviationViews/Helper/PollForThumbReady';
import { getDeviationResourceType, getDeviationType, getPrimaryTier, isDeviationAuthor, isFileLargerThanSizeOrEqual, isFileSizeBetween } from '../../../DeviationViews/_helpers';
import { getIsGif } from '../../../redux/deviations/selectors';
import MediaService from '../../../utils/DeviationMediaService';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { DeviationTypes } from '../../../types/deviation';
import deviationSelectorStyles from './DeviationSelector.scss';
const enhance = compose(withFilter);
const DeviationSelector = ({ deviations, allowedDeviationTypes, allowedDeviationResourceTypes, allowGifs, allowPremium, allowInTierContent, allowMature, minDeviationWidth, minDeviationHeight, minFileSize, maxFileSize, ignoreDeviationIds = [] })=>{
    const currentUser = useCurrentUser();
    const deviationRenderer = (deviation)=>{
        const isInTier = !!getPrimaryTier(deviation);
        const isOwner = isDeviationAuthor(deviation, currentUser);
        let isSelectionAllowed = !ignoreDeviationIds.includes(deviation.deviationId);
        const isGif = getIsGif(deviation);
        const { isPremium } = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData);
        const deviationType = getDeviationType(deviation);
        if (!allowPremium && isPremium || !allowMature && deviation.isMature || !allowInTierContent && isInTier || isInTier && !isOwner || !allowGifs && isGif || allowedDeviationTypes && !allowedDeviationTypes.includes(deviationType) || allowedDeviationResourceTypes && !allowedDeviationResourceTypes.includes(getDeviationResourceType(deviation))) {
            isSelectionAllowed = false;
        }
        if (minDeviationWidth || minDeviationHeight) {
            isSelectionAllowed = isSelectionAllowed && isFileLargerThanSizeOrEqual(MediaService.getLargestFullview(deviation), minDeviationWidth, minDeviationHeight);
        }
        if (minFileSize !== undefined || maxFileSize !== undefined) {
            isSelectionAllowed = isSelectionAllowed && isFileSizeBetween(MediaService.getLargestFullview(deviation), minFileSize, maxFileSize);
        }
        const isStatus = deviationType === DeviationTypes.STATUS;
        return /*#__PURE__*/ React.createElement(ContainerSize, {
            className: deviationSelectorStyles['thumb-measured-container']
        }, ({ width, height })=>/*#__PURE__*/ React.createElement(SelectableDeviationWrapper, {
                key: getDeviationEntityId(deviation),
                deviation: deviation,
                isDisabled: !isSelectionAllowed
            }, /*#__PURE__*/ React.createElement(PollForThumbReady, {
                deviation: deviation
            }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
                className: classnames(isStatus && deviationSelectorStyles['status-thumb']),
                deviation: deviation,
                width: width,
                height: height
            }))));
    };
    return /*#__PURE__*/ React.createElement(DeviationGrid, {
        deviations: deviations,
        deviationRenderer: deviationRenderer
    });
};
DeviationSelector.displayName = 'DeviationSelector';
export default enhance(DeviationSelector);
